// get language from locale for usage with react-intl. For eg: en_US => en
export const getLanguageFromLocale = (locale: string | undefined | null) => {
    if (locale && locale.trim()) {
        if (locale === 'pt_BR' || locale === 'pt-BR') {
            return 'pt-BR';
        }
        return locale.split('_')[0].split('-')[0].trim();
    }

    // default to 'en'
    return 'en';
};
